<script>
    import {getStyleValue, imageUrl, ignore} from "../../Common/tools"
    import TextEditor from "../../Common/TextEditor.svelte";
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange;

    function change(prop, val) {
      onChange();
      data[prop] = Object.assign({}, data[prop], {content: val});
    }

    const placeholder = External.resources + '/images/marketing/placeholders/310x430.png';
</script>
<tr>
    <th class="column has-columns" style="padding-left: 40px; padding-right: 40px; text-align: left;"
        width="{getStyleValue(globalStyle.width, 600)}">
        <table class="row" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
                <th class="column mobile-padding-bottom"
                    style="padding-right: 10px; font-weight: 400; text-align: left;"
                    width="{getStyleValue(globalStyle.width, 600)*.5}">
                    <div style="margin-bottom: 20px;">
                        <a href="{data.left.link}" style="pointer-events: none; color: #1F2225;">
                            <img src="{imageUrl(data.left, placeholder)}" alt=""
                                 style="border: 0; width: 100%; max-width: 310px"
                                 width="{getStyleValue(globalStyle.width, 600)*.5}">
                        </a>
                    </div>
                    <TextEditor data={data.left.content} meta={meta} onChange={val => change('left', val)} emailEditor={true} />
                </th>
                <th class="column mobile-padding-bottom" style="padding-left: 10px; font-weight: 400; text-align: left;"
                    width="{getStyleValue(globalStyle.width, 600)*.5}">
                    <div style="margin-bottom: 20px;">
                        <a href="{data.right.link}" style="pointer-events: none; color: #1F2225;">
                            <img src="{imageUrl(data.right, placeholder)}" alt=""
                                 style="border: 0; width: 100%; max-width: 310px;"
                                 width="{getStyleValue(globalStyle.width, 600)*.5}">
                        </a>
                    </div>
                    <TextEditor data={data.right.content} meta={meta} onChange={val => change('right', val)} emailEditor={true} />
                </th>
            </tr>
            </tbody>
        </table>
    </th>
</tr>
